// 扫码上架(스캔 재고확정) · 托盘号箱号扫描确认(파렛트↔박스 스캔) 공용 로직 — PC(LocationLabelScan·PalletBoxScan)와 핸드폰 페이지가 같이 쓴다.
// 서버 API 만 부른다. 화면 상태는 각 컴포넌트가 가진다.
import axios from 'axios';

// 스캔값 판별(위치번호 / 箱号 / 상품) — 판별 규칙은 서버 /api/warehouse/putaway/resolve 주석
export async function resolveScan(value) {
  const { data } = await axios.post('/api/warehouse/putaway/resolve', { value });
  if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || 'resolve failed');
  return data;
}

// 재고확정 — 기존 confirmStock 그대로(재고대기 → 중국재고, 제품위치 기록)
export async function confirmAt(items, location) {
  const { data } = await axios.post('/api/reqpurchase/import/confirmStock', {
    items: items.map(it => ({ _id: it._id, 위치번호: location }))
  });
  if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || 'confirm failed');
  return { results: data.results || [], skipped: data.skipped || [] };
}

// 파렛트 라벨 labelId = `<이름><MMDD>_<P|KD|H|><NN>` (labels/generatePallet). NOPALLET = 파렛트 없이 출고
export function looksLikePallet(v) {
  const s = String(v || '').trim();
  return s.toUpperCase() === 'NOPALLET' || /_(P|KD|H)?\d{2,}$/i.test(s);
}

// 박스 바코드는 labelId 의 줄바꿈을 - 로 찍는다 → 마지막 - 만 줄바꿈으로 되돌린다(화주 아이디·Z- 접두사의 - 는 그대로)
export function boxLabelIdFromScan(v) {
  const s = String(v || '').trim();
  return s.includes('\n') ? s : s.replace(/-(?=[^-]*$)/, '\n');
}

// 박스→파렛트 매핑 — 기존 /api/labels/mapBoxToPallet 그대로(새 필드 없음)
export async function mapBoxToPallet(scanValue, palletLabelId) {
  const { data } = await axios.post('/api/labels/mapBoxToPallet', { boxLabelId: boxLabelIdFromScan(scanValue), palletLabelId });
  if (data.요청결과 !== '성공') throw new Error(data.error || '映射失败(매핑 실패)');
  return true;
}

// 扫描出库 停用(2026-10-06 YZY) — 출고완료는 출고리스트 업로드(出库完成处理)로만. 서버 scanBox 도 거절한다
export const SCAN_OUT_OFF_MSG = '出库请上传出库清单(출고는 출고리스트 업로드로 처리)';
// 扫描出库 — (停用) 서버 /api/warehouse/outbound/scanBox 는 이제 거절만 한다
export async function scanOutBox(scanValue) {
  const { data } = await axios.post('/api/warehouse/outbound/scanBox', { value: scanValue });
  if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '扫描出库失败(스캔 출고 실패)');
  return data;
}
// 撤销 — 방금 스캔 출고한 건만(10분 안) 출고대기로 되돌린다
export async function undoScanOut(last) {
  const { data } = await axios.post('/api/warehouse/outbound/undoScanBox', {
    ids: last.shipped.map(s => s._id), labelId: last.box.labelId, palletSetByScan: !!last.palletSetByScan
  });
  if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '撤销失败(되돌리기 실패)');
  return data;
}

export function optionText(r) {
  return [r.옵션1_중국어, r.옵션2_중국어].filter(Boolean).join(' ');
}
export function qtyOf(r) {
  return (parseInt(r.입고수량) || parseInt(r.구매요청수량) || 0) + '个';
}
export function nowText() {
  const d = new Date();
  return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0') + ':' + String(d.getSeconds()).padStart(2, '0');
}

// 위치번호 범위 — 구역(A~C) × 열(1~10) × 층(1~5) → A-01-01 … (열·층은 자릿수 맞춤)
export function locationRange({ zoneFrom, zoneTo, colFrom, colTo, levelFrom, levelTo, pad }) {
  const z1 = String(zoneFrom || '').trim().toUpperCase();
  const z2 = String(zoneTo || z1).trim().toUpperCase();
  if (!/^[A-Z]$/.test(z1) || !/^[A-Z]$/.test(z2)) return [];
  const p = Math.min(3, Math.max(1, parseInt(pad) || 2));
  const nums = (a, b) => {
    const x = parseInt(a);
    const y = parseInt(b);
    if (!(x >= 0) || !(y >= x)) return [];
    const out = [];
    for (let i = x; i <= y && out.length < 200; i++) out.push(String(i).padStart(p, '0'));
    return out;
  };
  const cols = nums(colFrom, colTo);
  const levels = (levelFrom === '' || levelFrom === null || levelFrom === undefined) ? [''] : nums(levelFrom, levelTo);
  const out = [];
  for (let z = z1.charCodeAt(0); z <= z2.charCodeAt(0); z++) {
    for (const c of cols) {
      for (const l of levels) {
        out.push(String.fromCharCode(z) + '-' + c + (l ? '-' + l : ''));
        if (out.length >= 2000) return out;
      }
    }
  }
  return out;
}

export default { resolveScan, confirmAt, looksLikePallet, boxLabelIdFromScan, mapBoxToPallet, scanOutBox, undoScanOut, locationRange };
